import get from 'get-value';
import {SPARE_PARTS_LIST_FETCH_PENDING} from '../../actions/orders/actionSparePartsListPage';
import {
    SPARE_PARTS_ORDERS_TICKET_LOCKED,
    SPARE_PARTS_ORDERS_TICKET_LOCKED_ERROR,
    SPARE_PARTS_ORDERS_TICKET_LOCKED_FATAL
} from '../../constants/websocketCommands';
import {SPARE_PARTS_ORDERS_RESET_REDIRECT, SPARE_PARTS_ORDERS_SET_LOCK_TICKET} from '../../actions/orders/actionLockTicket';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const sparePartsListPage = (state = {
    correlationId: null,
    isLoading: false,
    isTableLoading: false,
    listData: [],
    pages: 0,
    isNextFromPivot: true,
    isNextPage: false,
}, action) => {
    switch (action.type) {
        case SPARE_PARTS_LIST_FETCH_PENDING: {
            return Object.assign({}, state, {isTableLoading: true});
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_LIST_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isTableLoading: false,
                    listData: get(action, 'payload.result.data', {default: []}),
                    pages: get(action, 'payload.result.pages', {default: 0}),
                    isNextFromPivot: get(action, 'payload.result.isNextFromPivot', false),
                    isNextPage: get(action, 'payload.result.isNextPage', false),
                    correlationId
                });
            }
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_LIST_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {isTableLoading: false, correlationId});
            }
        }
        default:
            return state;
    }
};

export const sparePartsListLockTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case SPARE_PARTS_ORDERS_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case SPARE_PARTS_ORDERS_TICKET_LOCKED_ERROR:
        case SPARE_PARTS_ORDERS_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case SPARE_PARTS_ORDERS_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case SPARE_PARTS_ORDERS_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
